import Constants from "expo-constants";
import React from "react";
import { View, Text } from "react-native-ui-lib";
import queryString from "query-string-es5";
import * as SecureStore from "@towersystems/roam-common-native/lib/utilities/storage";

export interface AppPasswordGuardProps {
  children?: React.ReactNode;
}

const APP_PASSWORD_KEY = "__APP_PASSWORD__";

export const AppPasswordGuard = ({ children }: AppPasswordGuardProps) => {
  const [booted, setBooted] = React.useState(false);

  const [canPass, setCanPass] = React.useState(false);

  const passwordRequired =
    Constants.manifest?.extra?.appPasswordRequired === "true";

  const password = Constants.manifest?.extra?.appPassword;

  React.useEffect(() => {
    if (!passwordRequired) {
      setCanPass(true);
      setBooted(true);

      return;
    } else {
      checkPassword();
    }
  }, []);

  const checkPassword = async () => {
    if (passwordRequired) {
      const parsed = queryString.parse(location.search);

      const parsedPassword = parsed.app_password;
      const existingPassword = await SecureStore.getItemAsync(APP_PASSWORD_KEY);

      const normalizedPassword = parsedPassword || existingPassword;

      if (normalizedPassword && normalizedPassword === password) {
        await SecureStore.storeItemAsync(
          APP_PASSWORD_KEY,
          normalizedPassword as string
        );
        setCanPass(true);
        setBooted(true);
      } else {
        setBooted(true);
      }
    } else {
      setBooted(true);
    }
  };

  if (!booted) {
    return null;
  }

  if (!canPass) {
    return (
      <View>
        <Text>Not Allowed.</Text>
      </View>
    );
  }

  return <>{children}</>;
};
